import Vue from 'vue'

Vue.directive('awaitload',{
	bind(el,binding,vnode){
		console.log('bind',el,binding,vnode);

		// 往vue实例上挂在方法
		// vnode.context.abc = () => { }

		// 这个是传进来的值
		console.log('binding.value',el,binding.value);

		el.style.cssText = `
			position: relative;
			width: fit-content;
		`

		let div = document.createElement('div')
		div.className = 'loading-mask'

		div.style.cssText = `
			position: absolute;
			top: 0; left: 0; bottom: 0; right: 0;
			opacity: 0;
			background:pink;
			zIndex:-10;
			display: flex;
			align-items: center;
			justify-content: center;
		`;

		let img = document.createElement('img');
		img.src = 'https://img2.baidu.com/it/u=638285213,1746517464&fm=253&fmt=auto&app=120&f=JPEG?w=1422&h=800';
		img.style.cssText = `max-width: 60%; max-height: 60%;`

		div.appendChild(img)
		el.appendChild(div)
	},
	update(el,binding){
		// console.log('update',el,binding);
		let loadingMask = el.querySelector('.loading-mask')
		loadingMask.style.zIndex = (binding.value?'':'-')+10
		loadingMask.style.opacity = (binding.value?'':'-')+10
	},
	unbind(el){
		// console.log('unbind',el);
	}
})